import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Paper,
  Fab,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Switch,
  FormControlLabel,
  Pagination,
  Stack,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SyncIcon from "@mui/icons-material/Sync";
import WarningIcon from "@mui/icons-material/Warning";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CustomSnackbar from "../components/Message.Component";
import IntegrationLogo from "./components/IntegrationsLogo.component";
import {
  useGetAvailableIntegrations,
  useGetMarketplaceChannels,
  useUpdateMarketplaceChannelStatus,
  useDeleteMarketplaceChannel,
  useCreateMarketplaceChannel,
  useGetRequestMercadoLivreOAuthURI,
  useGetRequestBlingOAuthURI,
  useGetRequestShopeeOAuthURI,
} from "../../client/hooks/marketplace/marketplace.queries";

export default function IntegrationsPage() {
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmEditDialog, setOpenConfirmEditDialog] = useState(false);
  const [currentIntegration, setCurrentIntegration] = useState(null);
  const [originalIntegration, setOriginalIntegration] = useState(null);
  const [alert, setAlert] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [updateId, setUpdateId] = useState(null);
  const [updateData, setUpdateData] = useState(null);
  const [execUpdate, setExecUpdate] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [execDelete, setExecDelete] = useState(false);
  const [updateCount, setUpdateCount] = useState(0);

  const [requestOAuth, setRequestOAuth] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  
  const [openConfigDialog, setOpenConfigDialog] = useState(false);
  const [configVariables, setConfigVariables] = useState([]);
  const [createChannelData, setCreateChannelData] = useState(null);
  const [execCreate, setExecCreate] = useState(false);
  
  const [addingAdditionalAccount, setAddingAdditionalAccount] = useState(false);

  const {
    data: integrationsData,
    isLoading: isLoadingIntegrations,
    error: integrationsError,
  } = useGetAvailableIntegrations({
    page: page - 1,
    size: itemsPerPage,
  });

  const {
    data: channelsData,
    isLoading: isLoadingChannels,
    error: channelsError,
    refetch: refetchChannels,
  } = useGetMarketplaceChannels();

  let {
    data: updatedData,
    isSuccess,
    error: updateError,
    refetch: refetchUpdate,
  } = useUpdateMarketplaceChannelStatus(updateId, updateData, execUpdate);

  const { isSuccess: deleteSuccess, error: deleteError } =
    useDeleteMarketplaceChannel(deleteId, execDelete);
  const {
    data: oauthData,
    isSuccess: oauthSuccess,
    isLoading: oauthLoading,
    error: oauthError,
  } = useGetRequestMercadoLivreOAuthURI(
    selectedIntegration?.channel === "MERCADO_LIVRE" ? "MERCADO_LIVRE" : null,
    requestOAuth && selectedIntegration?.channel === "MERCADO_LIVRE"
  );

  const {
    data: blingOauthData,
    isSuccess: blingOauthSuccess,
    isLoading: blingOauthLoading,
    error: blingOauthError,
  } = useGetRequestBlingOAuthURI(
    selectedIntegration?.channel === "BLING" ? "BLING" : null,
    requestOAuth && selectedIntegration?.channel === "BLING"
  );

  const {
    data: shopeeOauthData,
    isSuccess: shopeeOauthSuccess,
    isLoading: shopeeOauthLoading,
    error: shopeeOauthError,
  } = useGetRequestShopeeOAuthURI(
    selectedIntegration?.channel === "SHOPEE" ? "SHOPEE" : null,
    requestOAuth && selectedIntegration?.channel === "SHOPEE"
  );

  const {
    data: createChannelResult,
    isSuccess: createChannelSuccess,
    error: createChannelError,
  } = useCreateMarketplaceChannel(createChannelData, execCreate);

  useEffect(() => {
    if (integrationsData) {
      setTotalPages(integrationsData.totalPages || 1);
      setTotalItems(integrationsData.totalElements || 0);
    }
  }, [integrationsData]);

  useEffect(() => {
    if (isSuccess && execUpdate) {
      setSuccessMsg(`Status da integração alterado com sucesso!`);
      setAlert(true);
      setExecUpdate(false);
      setUpdateId(null);
      setUpdateData(null);
      refetchChannels();
      setUpdateCount((prev) => prev + 1);
    } else if (updateError) {
      setErrorMsg(
        updateError?.message || "Erro ao atualizar status da integração"
      );
      setAlert(true);
      setExecUpdate(false);
      setUpdateId(null);
      setUpdateData(null);
    }
  }, [isSuccess, updateError, refetchChannels, execUpdate]);

  useEffect(() => {
    if (deleteSuccess) {
      setSuccessMsg(`Integração removida com sucesso!`);
      setAlert(true);
      setExecDelete(false);
      setDeleteId(null);
      
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else if (deleteError) {
      setErrorMsg(deleteError?.message || "Erro ao remover integração");
      setAlert(true);
      setExecDelete(false);
      setDeleteId(null);
    }
  }, [deleteSuccess, deleteError]);
  useEffect(() => {
    if (oauthSuccess && oauthData && oauthData.oauth_uri) {
      window.location.href = oauthData.oauth_uri;
      setRequestOAuth(false);
      if (addingAdditionalAccount) {
        setAddingAdditionalAccount(false);
        handleCloseEditDialog();
      }
    } else if (oauthError) {
      setErrorMsg(
        addingAdditionalAccount 
          ? "Erro ao iniciar processo de autenticação para conta adicional no Mercado Livre. Tente novamente."
          : "Erro ao iniciar processo de autenticação com Mercado Livre. Tente novamente."
      );
      setAlert(true);
      setRequestOAuth(false);
      if (addingAdditionalAccount) {
        setAddingAdditionalAccount(false);
      }
    }
  }, [oauthData, oauthSuccess, oauthError, addingAdditionalAccount]);

  useEffect(() => {
    if (blingOauthSuccess && blingOauthData && blingOauthData.oauth_uri) {
      window.location.href = blingOauthData.oauth_uri;
      setRequestOAuth(false);
    } else if (blingOauthError) {
      setErrorMsg(
        "Erro ao iniciar processo de autenticação com Bling. Tente novamente."
      );
      setAlert(true);
      setRequestOAuth(false);
    }
  }, [blingOauthData, blingOauthSuccess, blingOauthError]);

  useEffect(() => {
    if (shopeeOauthSuccess && shopeeOauthData && shopeeOauthData.oauth_uri) {
      window.location.href = shopeeOauthData.oauth_uri;
      setRequestOAuth(false);
      if (addingAdditionalAccount) {
        setAddingAdditionalAccount(false);
        handleCloseEditDialog();
      }
    } else if (shopeeOauthError) {
      setErrorMsg(
        addingAdditionalAccount 
          ? "Erro ao iniciar processo de autenticação para conta adicional no Shopee. Tente novamente."
          : "Erro ao iniciar processo de autenticação com Shopee. Tente novamente."
      );
      setAlert(true);
      setRequestOAuth(false);
      if (addingAdditionalAccount) {
        setAddingAdditionalAccount(false);
      }
    }
  }, [shopeeOauthData, shopeeOauthSuccess, shopeeOauthError, addingAdditionalAccount]);

  useEffect(() => {
    if (createChannelSuccess && execCreate) {
      setSuccessMsg(`Canal integrado com sucesso!`);
      setAlert(true);
      setExecCreate(false);
      setCreateChannelData(null);
      setOpenConfigDialog(false);
      setConfigVariables([]);
      handleCloseDialog();
      
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else if (createChannelError) {
      setErrorMsg(
        createChannelError?.message || "Erro ao integrar canal"
      );
      setAlert(true);
      setExecCreate(false);
      setCreateChannelData(null);
    }
  }, [createChannelSuccess, createChannelError, execCreate]);

  const integrations = channelsData?.data || [];
  const availableIntegrations = integrationsData?.data || [];
  
  const marketplaceChannels = [
    {
      id: "INTELIPOST",
      name: "Intelipost",
      description: "Integração com serviços de logística da Intelipost",
      variables: [
        { key: "api-key", label: "API Key", type: "text", required: true }
      ]
    }
  ];

  const handleOpenDialog = () => {
    setPage(1);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleAddIntegration = (integration) => {
    setSelectedIntegration(integration);

    if (
      integration.channel === "MERCADO_LIVRE" ||
      integration.channel === "BLING" ||
      integration.channel === "SHOPEE"
    ) {
      setRequestOAuth(true);
    } else if (integration.channel === "INTELIPOST") {
      // Encontra a configuração do canal INTELIPOST
      const channelConfig = marketplaceChannels.find(ch => ch.id === integration.channel);
      if (channelConfig) {
        setConfigVariables(channelConfig.variables.map(v => ({ ...v, value: "" })));
        setOpenConfigDialog(true);
      }
    } else {
      setSuccessMsg(`Integração ${integration.name} adicionada com sucesso!`);
      setAlert(true);
      handleCloseDialog();
      refetchChannels();
    }
  };

  const handleAddAdditionalAccount = () => {
    if (currentIntegration?.channel === "SHOPEE") {
      setAddingAdditionalAccount(true);
      setSelectedIntegration({ channel: "SHOPEE", name: "Shopee" });
      setRequestOAuth(true);
    } else if (currentIntegration?.channel === "MERCADO_LIVRE") {
      setAddingAdditionalAccount(true);
      setSelectedIntegration({ channel: "MERCADO_LIVRE", name: "Mercado Livre" });
      setRequestOAuth(true);
    }
  };

  const handleCloseEditDialogWithReset = () => {
    setAddingAdditionalAccount(false);
    handleCloseEditDialog();
  };

  const getAccountsCount = (integration) => {
    if (integration?.accounts_id && Array.isArray(integration.accounts_id)) {
      return integration.accounts_id.length > 0 ? integration.accounts_id.length : 1; // Return 1 if no accounts, assuming at least one account exists
    }
    return 1; // Default to 1 if no accounts_id field
  };


  const handleCloseConfigDialog = () => {
    setOpenConfigDialog(false);
    setConfigVariables([]);
    setSelectedIntegration(null);
  };

  const handleConfigVariableChange = (index, value) => {
    const newVariables = [...configVariables];
    newVariables[index].value = value;
    setConfigVariables(newVariables);
  };

  const handleCreateChannel = () => {
    if (!selectedIntegration) return;

    const variables = {};
    configVariables.forEach(variable => {
      variables[variable.key] = variable.value;
    });

    const channelData = {
      channel: selectedIntegration.channel,
      variables: variables
    };

    setCreateChannelData(channelData);
    setExecCreate(true);
  };

  const isConfigFormValid = () => {
    return configVariables.every(variable => 
      !variable.required || (variable.value && variable.value.trim() !== "")
    );
  };

  const handleEditIntegration = (id) => {
    const integration = integrations.find((i) => i.id === id);
    setOriginalIntegration({ ...integration });
    setCurrentIntegration({ ...integration });
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setCurrentIntegration(null);
    setOriginalIntegration(null);
  };

  const handleOpenConfirmEdit = () => {
    if (currentIntegration?.active !== originalIntegration?.active) {
      setOpenConfirmEditDialog(true);
    } else {
      handleCloseEditDialog();
    }
  };

  const handleCloseConfirmEdit = () => {
    setOpenConfirmEditDialog(false);
  };

  const handleToggleStatus = () => {
    if (currentIntegration?.active !== originalIntegration?.active) {
      setExecUpdate(false);

      setTimeout(() => {
        setUpdateId(currentIntegration.id);
        setUpdateData({ active: currentIntegration.active });
        setExecUpdate(true);
      }, 50);
    }

    handleCloseConfirmEdit();
    handleCloseEditDialog();
  };

  const handleDeleteRequest = (id) => {
    const integration = integrations.find((i) => i.id === id);
    if (!integration) {
      setErrorMsg("Integração não encontrada");
      setAlert(true);
      return;
    }
    setCurrentIntegration(integration);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setCurrentIntegration(null);
  };

  const handleDeleteIntegration = () => {
    if (!currentIntegration || !currentIntegration.id) {
      setErrorMsg("Não foi possível identificar a integração para exclusão");
      setAlert(true);
      handleCloseConfirmDialog();
      return;
    }

    setDeleteId(currentIntegration.id);
    setExecDelete(true);
    handleCloseConfirmDialog();
  };

  const getStatusText = (active) => (active ? "Ativo" : "Inativo");

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <CustomSnackbar
        open={alert}
        onClose={() => setAlert(false)}
        severity={errorMsg ? "error" : "success"}
        message={errorMsg || successMsg}
      />

      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            fontWeight: 600,
            color: "#2c3e50",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <SyncIcon color="primary" />
          Integrações
        </Typography>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            border: "1px solid rgba(224, 224, 224, 0.5)",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="tabela de integrações">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f5f8fa",
                  "& th": {
                    fontWeight: "bold",
                    color: "#455a64",
                    py: 2,
                    borderBottom: "2px solid rgba(224, 224, 224, 0.8)",
                  },
                }}
              >
                <TableCell>Integração</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Contas</TableCell>
                <TableCell align="left">Última Sincronização</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoadingChannels ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ textAlign: "center", py: 6 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : channelsError ? (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    sx={{ textAlign: "center", py: 6, color: "error.main" }}
                  >
                    <Typography>
                      Erro ao carregar integrações. Tente novamente.
                    </Typography>
                    <Button
                      onClick={() => refetchChannels()}
                      variant="outlined"
                      color="primary"
                      sx={{ mt: 2 }}
                    >
                      Recarregar
                    </Button>
                  </TableCell>
                </TableRow>
              ) : integrations.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ textAlign: "center", py: 6 }}>
                    <Typography color="text.secondary">
                      Nenhuma integração encontrada
                    </Typography>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={handleOpenDialog}
                      sx={{ mt: 2 }}
                    >
                      Adicionar Integração
                    </Button>
                  </TableCell>
                </TableRow>
              ) : (
                integrations.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": { borderBottom: 0 },
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.02)" },
                      bgcolor:
                        index % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.01)",
                      transition: "background-color 0.2s",
                    }}
                  >
                    <TableCell component="th" scope="row" sx={{ py: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <Box
                          sx={{
                            p: 0.5,
                            border: "1px solid rgba(0,0,0,0.05)",
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 120,
                            height: 70,
                            overflow: "hidden",
                          }}
                        >
                          <IntegrationLogo
                            name={row.name}
                            logo_url={row.logo_url}
                            size={100}
                          />
                        </Box>
                        <Typography sx={{ fontWeight: 500, color: "#37474f" }}>
                          {row.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell align="left">
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 2,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          letterSpacing: "0.025em",
                          bgcolor: row.active
                            ? "rgba(46, 125, 50, 0.08)"
                            : "rgba(211, 47, 47, 0.08)",
                          color: row.active ? "#2e7d32" : "#d32f2f",
                          "&::before": {
                            content: '""',
                            display: "block",
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            bgcolor: row.active ? "#2e7d32" : "#d32f2f",
                            mr: 0.8,
                          },
                        }}
                      >
                        {getStatusText(row.active)}
                      </Box>
                    </TableCell>
                    <TableCell align="left">
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 2,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          bgcolor: "rgba(25, 118, 210, 0.08)",
                          color: "#1976d2",
                        }}
                      >
                        {getAccountsCount(row)} conta{getAccountsCount(row) > 1 ? 's' : ''}
                      </Box>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ color: "#607d8b", fontSize: "0.9rem" }}
                    >
                      {row.updatedAt}
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <Tooltip title="Editar integração">
                          <IconButton
                            onClick={() => handleEditIntegration(row.id)}
                            size="small"
                            sx={{
                              bgcolor: "rgba(25, 118, 210, 0.08)",
                              "&:hover": {
                                bgcolor: "rgba(25, 118, 210, 0.15)",
                              },
                            }}
                          >
                            <CreateOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Remover integração">
                          <IconButton
                            onClick={() => handleDeleteRequest(row.id)}
                            size="small"
                            sx={{
                              bgcolor: "rgba(211, 47, 47, 0.08)",
                              "&:hover": {
                                bgcolor: "rgba(211, 47, 47, 0.15)",
                              },
                            }}
                          >
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Fab
        color="primary"
        aria-label="add"
        onClick={handleOpenDialog}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <AddIcon />
      </Fab>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Adicionar Nova Integração</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Selecione uma integração para adicionar:
          </Typography>
          {isLoadingIntegrations || oauthLoading || blingOauthLoading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                my: 4,
                gap: 2,
              }}
            >
              <CircularProgress />
              {(oauthLoading || blingOauthLoading) && (
                <Typography color="text.secondary">
                  Iniciando processo de autenticação...
                </Typography>
              )}
            </Box>
          ) : integrationsError ? (
            <Box sx={{ textAlign: "center", color: "error.main", my: 3 }}>
              <Typography>
                Erro ao carregar integrações disponíveis. Tente novamente.
              </Typography>
              <Button
                onClick={() => document.location.reload()}
                variant="outlined"
                color="primary"
                sx={{ mt: 2 }}
              >
                Recarregar
              </Button>
            </Box>
          ) : (
            <>
              <List sx={{ bgcolor: "#f9f9f9", borderRadius: "8px", mb: 2 }}>
                {availableIntegrations.map((integration, index) => (
                  <React.Fragment key={integration.id}>
                    <ListItem
                      button
                      onClick={() =>
                        integration.available
                          ? handleAddIntegration(integration)
                          : null
                      }
                      disabled={!integration.available}
                      sx={{
                        "&:hover": {
                          backgroundColor: integration.available
                            ? "#dfe6e9"
                            : "inherit",
                        },
                        transition: "background-color 0.2s",
                        py: 1.5,
                        opacity: integration.available ? 1 : 0.6,
                        cursor: integration.available
                          ? "pointer"
                          : "not-allowed",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          minWidth: 80,
                          width: 80,
                          mr: 2,
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            width: 70,
                            height: 50,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0,
                            border: "1px solid rgba(0,0,0,0.05)",
                            borderRadius: 1,
                            backgroundColor: "white",
                            overflow: "hidden",
                          }}
                        >
                          <IntegrationLogo
                            name={integration.name}
                            logo_url={integration.logo_url}
                            size={60}
                            sx={{
                              filter: !integration.available
                                ? "grayscale(100%)"
                                : "none",
                              maxWidth: "100%",
                              maxHeight: "100%",
                            }}
                          />
                          {!integration.available && (
                            <Typography
                              variant="caption"
                              sx={{
                                position: "absolute",
                                bottom: -4,
                                right: -4,
                                backgroundColor: "#ff9800",
                                color: "white",
                                padding: "1px 4px",
                                borderRadius: "3px",
                                fontSize: "9px",
                                fontWeight: "bold",
                                zIndex: 2,
                              }}
                            >
                              EM BREVE
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <ListItemText
                          primary={
                            <Typography noWrap sx={{ fontWeight: 500 }}>
                              {integration.name}
                            </Typography>
                          }
                          secondary={
                            <Box sx={{ mt: 0.5 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  lineHeight: 1.2,
                                }}
                              >
                                {integration.description}
                              </Typography>
                              {!integration.available && (
                                <Typography
                                  component="span"
                                  sx={{
                                    display: "block",
                                    color: "#f57c00",
                                    mt: 0.5,
                                    fontSize: "12px",
                                  }}
                                >
                                  Integração indisponível no momento
                                </Typography>
                              )}
                            </Box>
                          }
                          primaryTypographyProps={{ noWrap: true }}
                        />
                      </Box>

                      <Box
                        sx={{
                          ml: 1,
                          display: "flex",
                          alignItems: "center",
                          flexShrink: 0,
                        }}
                      >
                        {integration.available ? (
                          <SyncIcon color="primary" fontSize="small" />
                        ) : (
                          <Tooltip title="Indisponível no momento">
                            <span>
                              <SyncIcon color="disabled" fontSize="small" />
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                    </ListItem>
                    {index < availableIntegrations.length - 1 && <Divider />}
                  </React.Fragment>
                ))}

                {availableIntegrations.length === 0 && (
                  <ListItem sx={{ justifyContent: "center", py: 4 }}>
                    <Typography color="text.secondary">
                      Nenhuma integração disponível encontrada
                    </Typography>
                  </ListItem>
                )}
              </List>

              {totalPages > 1 && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <Stack spacing={2}>
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      size="medium"
                      shape="rounded"
                      showFirstButton={totalPages > 3}
                      showLastButton={totalPages > 3}
                    />
                  </Stack>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {!isLoadingIntegrations &&
                !integrationsError &&
                `Mostrando ${(page - 1) * itemsPerPage + 1} - ${Math.min(page * itemsPerPage, totalItems)} de ${totalItems}`}
            </Typography>
            <Button onClick={handleCloseDialog} color="primary">
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 2,
            borderBottom: "1px solid #e9ecef",
            bgcolor: "#fafbfc",
            fontWeight: 600,
            fontSize: "1.1rem",
            color: "#343a40",
          }}
        >
          Gerenciar Integração
        </DialogTitle>
        <DialogContent
          sx={{
            p: 3,
            bgcolor: "white",
          }}
        >
          {currentIntegration && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              {/* Cabeçalho da Integração */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2.5,
                  p: 2,
                  borderRadius: 1.5,
                  bgcolor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                }}
              >
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 1.5,
                    bgcolor: "white",
                    border: "1px solid #e9ecef",
                    flexShrink: 0,
                  }}
                >
                  <IntegrationLogo
                    name={currentIntegration.name}
                    logo_url={currentIntegration.logo_url}
                    size={60}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: "1.1rem" }}>
                    {currentIntegration.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#6c757d", fontSize: "0.85rem" }}>
                    ID: {currentIntegration.id}
                  </Typography>
                </Box>
              </Box>

              {/* Controle de Status */}
              <Box
                sx={{
                  p: 2,
                  borderRadius: 1.5,
                  border: "1px solid #dee2e6",
                  bgcolor: "white",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 1.5, color: "#495057", fontSize: "1rem" }}
                >
                  Status da Integração
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    borderRadius: 1.5,
                    bgcolor: currentIntegration.active
                      ? "rgba(40, 167, 69, 0.06)"
                      : "rgba(220, 53, 69, 0.06)",
                    border: "1px solid",
                    borderColor: currentIntegration.active
                      ? "rgba(40, 167, 69, 0.15)"
                      : "rgba(220, 53, 69, 0.15)",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        bgcolor: currentIntegration.active ? "#28a745" : "#dc3545",
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 500,
                        color: currentIntegration.active ? "#155724" : "#721c24",
                      }}
                    >
                      {getStatusText(currentIntegration.active)}
                    </Typography>
                  </Box>
                  <Switch
                    checked={currentIntegration.active}
                    onChange={() => {
                      setCurrentIntegration({
                        ...currentIntegration,
                        active: !currentIntegration.active,
                      });
                    }}
                    color="primary"
                    size="medium"
                  />
                </Box>
              </Box>
              
              {/* Informações da Integração */}
              <Box
                sx={{
                  p: 2.5,
                  borderRadius: 2,
                  border: "1px solid #e9ecef",
                  bgcolor: "white",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 2, color: "#495057" }}
                >
                  Informações da Integração
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: 2,
                      bgcolor: "#f8f9fa",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Contas vinculadas
                    </Typography>
                    <Box
                      sx={{
                        px: 2,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor: "#007bff",
                        color: "white",
                        fontSize: "0.875rem",
                        fontWeight: 600,
                      }}
                    >
                      {getAccountsCount(currentIntegration)}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderRadius: 2,
                      bgcolor: "#f8f9fa",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Última sincronização
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {currentIntegration.updatedAt || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              
              {/* Botão para adicionar conta adicional - para SHOPEE e MERCADO_LIVRE */}
              {(currentIntegration?.channel === "SHOPEE" || currentIntegration?.channel === "MERCADO_LIVRE") && (
                <Box
                  sx={{
                    p: 2.5,
                    borderRadius: 2,
                    border: "1px solid #e9ecef",
                    bgcolor: "white",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#495057" }}
                  >
                    Contas Adicionais
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Adicione mais contas do {currentIntegration?.channel === "SHOPEE" ? "Shopee" : "Mercado Livre"} para esta integração
                  </Typography>
                  <Button
                    onClick={handleAddAdditionalAccount}
                    variant="contained"
                    color="primary"
                    startIcon={<PersonAddIcon />}
                    fullWidth
                    disabled={addingAdditionalAccount || oauthLoading || shopeeOauthLoading}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: "none",
                      boxShadow: "0 2px 8px rgba(25, 118, 210, 0.2)",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                      },
                      "&:disabled": {
                        bgcolor: "#6c757d",
                        color: "white",
                      },
                    }}
                  >
                    {addingAdditionalAccount || shopeeOauthLoading || (currentIntegration?.channel === "MERCADO_LIVRE" && oauthLoading) ? (
                      <>
                        <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
                        Redirecionando...
                      </>
                    ) : (
                      "Adicionar Conta Adicional"
                    )}
                  </Button>
                </Box>
              )}

            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2.5,
            borderTop: "1px solid #e9ecef",
            bgcolor: "#fafbfc",
            gap: 1.5,
          }}
        >
          <Button
            onClick={handleCloseEditDialogWithReset}
            variant="outlined"
            sx={{
              px: 2.5,
              py: 1,
              borderRadius: 1.5,
              textTransform: "none",
              fontWeight: 500,
              borderColor: "#dee2e6",
              color: "#6c757d",
              "&:hover": {
                borderColor: "#adb5bd",
                bgcolor: "rgba(108, 117, 125, 0.04)",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleOpenConfirmEdit}
            variant="contained"
            color="primary"
            sx={{
              px: 2.5,
              py: 1,
              borderRadius: 1.5,
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(25, 118, 210, 0.15)",
              "&:hover": {
                boxShadow: "0 3px 10px rgba(25, 118, 210, 0.25)",
              },
            }}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmEditDialog}
        onClose={handleCloseConfirmEdit}
        maxWidth="xs"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SyncIcon color="primary" />
          Confirmar Alteração
        </DialogTitle>
        <DialogContent>
          {currentIntegration && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                p: 1,
              }}
            >
              <Typography variant="body1">
                Confirmar alteração de status da integração{" "}
                <strong>{currentIntegration.name}</strong>?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  p: 2,
                  bgcolor: currentIntegration.active
                    ? "rgba(46, 125, 50, 0.1)"
                    : "rgba(211, 47, 47, 0.1)",
                  borderRadius: 1,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 60,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IntegrationLogo
                    name={currentIntegration.name}
                    logo_url={currentIntegration.logo_url}
                    size={80}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle2">
                    {currentIntegration.name}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 0.5,
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        bgcolor: currentIntegration.active
                          ? "#2e7d32"
                          : "#d32f2f",
                        color: "white",
                        px: 1,
                        py: 0.3,
                        borderRadius: 0.5,
                        fontWeight: "medium",
                      }}
                    >
                      {getStatusText(currentIntegration.active)}
                    </Typography>
                    <Typography variant="caption">
                      {currentIntegration.active
                        ? "A integração sincronizará dados automaticamente"
                        : "Sincronização de dados interrompida"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontStyle: "italic" }}
              >
                {currentIntegration.active
                  ? "Esta alteração ativará a sincronização de dados com este serviço."
                  : "Esta alteração interromperá a sincronização de dados com este serviço."}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmEdit} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleToggleStatus}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        maxWidth="xs"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon color="warning" />
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent>
          {currentIntegration && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                p: 1,
              }}
            >
              <Typography variant="body1">
                Tem certeza que deseja remover a integração com{" "}
                <strong>{currentIntegration.name}</strong>?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  p: 2,
                  bgcolor: "rgba(211, 47, 47, 0.05)",
                  borderRadius: 1,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 60,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IntegrationLogo
                    name={currentIntegration.name}
                    logo_url={currentIntegration.logo_url}
                    size={80}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle2">
                    {currentIntegration.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Status: {getStatusText(currentIntegration.active)}
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: "medium" }}
              >
                Esta ação não poderá ser desfeita.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteIntegration}
            variant="contained"
            color="error"
          >
            Excluir Integração
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfigDialog}
        onClose={handleCloseConfigDialog}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: '520px',
            maxHeight: '320px'
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SyncIcon color="primary" />
          Configurar Canal: {selectedIntegration?.name}
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Configure as variáveis necessárias para integrar com {selectedIntegration?.name}
          </Typography>

          <Box sx={{ mt: 2 }}>
            {configVariables.map((variable, index) => (
              <Box key={variable.key} sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  label={variable.label}
                  value={variable.value}
                  onChange={(e) => handleConfigVariableChange(index, e.target.value)}
                  required={variable.required}
                  type={variable.type}
                  variant="outlined"
                  helperText={variable.required ? "Campo obrigatório" : ""}
                />
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfigDialog} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleCreateChannel}
            variant="contained"
            color="primary"
            disabled={!isConfigFormValid()}
          >
            Integrar Canal
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
